import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "preview"]
  static values = {
    penColor: { type: String, default: "rgb(0, 0, 0)" },
    backgroundColor: { type: String, default: "rgb(255, 255, 255)" },
    data: String,
  }

  declare readonly canvasTarget: HTMLCanvasElement
  declare readonly inputTarget: HTMLInputElement
  declare readonly penColorValue: string
  declare readonly backgroundColorValue: string
  declare readonly dataValue: string
  declare readonly hasDataValue: boolean
  declare readonly hasPreviewTarget: boolean
  declare readonly previewTarget: HTMLElement

  private signaturePad: SignaturePad | null = null

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: this.backgroundColorValue,
      penColor: this.penColorValue,
    })

    this.resizeCanvas()

    if (this.hasDataValue && this.dataValue) {
      this.signaturePad.fromDataURL(this.dataValue)
    }

    this.signaturePad.addEventListener("endStroke", () => {
      this.updateInput()
    })
  }

  disconnect() {
    if (this.signaturePad) {
      this.signaturePad.off()
      this.signaturePad = null
    }
  }

  clear() {
    if (this.signaturePad) {
      this.signaturePad.clear()
      this.inputTarget.value = ""
      if (this.hasPreviewTarget) {
        this.previewTarget.hidden = true
      }
      this.dispatch("change")
    }
  }

  private updateInput() {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      this.inputTarget.value = this.signaturePad.toDataURL()
    } else {
      this.inputTarget.value = ""
    }
    this.dispatch("change")
  }

  private resizeCanvas() {
    const canvas = this.canvasTarget
    const rect = canvas.getBoundingClientRect()
    const dpr = window.devicePixelRatio || 1

    canvas.width = rect.width * dpr
    canvas.height = rect.height * dpr
    canvas.style.width = rect.width + "px"
    canvas.style.height = rect.height + "px"

    const ctx = canvas.getContext("2d")
    if (ctx) {
      ctx.scale(dpr, dpr)
    }
  }
}
